import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { hairAnalyserMessages } from '../messages';
import { StyledTitle } from '../styled';

export const Title = () => {
  return (
    <StyledTitle>
      <FormattedMessage {...hairAnalyserMessages.hairAnalyserTitle} />
    </StyledTitle>
  );
};
